import React from 'react'
import useSWR from 'swr'
import { create } from 'zustand'
import Loader from '@/components/ui/Loader'
import { Card, CardContent } from '@/components/ui/card'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import DataTableToolbar from './data-table-toolbar'
import { Columns } from './data-table-column'

export const useForm = create((set) => ({
  range: 7,
  updateRange: (value) => set({ range: value }),
}))

const Index = () => {
  const { range } = useForm()
  const { data, isLoading, isValidating, mutate } = useSWR([
    `/frames/report`,
    { range },
  ])
  const table = useReactTable({
    data: data,
    columns: Columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })
  if (isLoading || isValidating) return <Loader />
  if (!data) return <EmptyDatas />
  return (
    <>
      <DataTableToolbar mutate={mutate} />
      <Card className="mt-4">
        <CardContent>
          <Table table={table} />
        </CardContent>
      </Card>
    </>
  )
}

export default Index
